import DemandForecasting from './DemandForecasting'
import LeadTime from './LeadTime'
import LeadTimeBomDetail from './LeadTimeBomDetail'
import Sales from './Sales'

export const ROUTES = [
  {
    component: Sales,
    isPublic: true,
    path: '/planning',
    slug: 'planning-sales',
    title: 'Planning - Sales',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: LeadTime,
    isPublic: true,
    path: '/planning/lead-time',
    slug: 'planning-lead-time',
    title: 'Planning - Lead Time & MOQ Overview',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: LeadTimeBomDetail,
    isPublic: true,
    path: '/planning/lead-time/:productId/bom',
    slug: 'planning-lead-time-bom-detail',
    title: 'Planning - Lead Time BOM Detail',
    isProtected: true,
    showMenu: false,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: DemandForecasting,
    isPublic: true,
    path: '/planning/demand-forecasting',
    slug: 'planning-demand-forecasting',
    title: 'Planning - Demand & Forecasting',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
